<template>
  <div class="container">
    <el-card class="card">
      <img src="~@/assets/MySideline_PrimaryLogo_black.svg">
      <h3>Under Construction</h3>
      <p>We're working to bring you more and better features.</p>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UnderConstruction',
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  .card {
    margin: 20px auto;
    width: 50%;
    max-width: 100%;
    overflow: hidden;
    text-align: center;

    img {
      width: 70%;
    }
  }
  @media only screen and (max-width: $sm) {
    .card {
      width: 80%;
    }
  }
}
</style>
